import { memo } from 'react';
import { cn } from '@/shared/utils/cn';

export interface HelperTextProps {
  children: React.ReactNode;
  type?: 'error' | 'size' | 'custom';
  className?: string;
}

/**
 * HelperText - Componente atómico para mostrar textos de ayuda o descripción.
 * Sigue las especificaciones de Figma: caption-xs
 *
 * @example
 * <HelperText type="error">Algo salió mal</HelperText>
 *
 * @example
 * <HelperText type="size">200MB de 512MB</HelperText>
 */
export const HelperText = memo(({ children, type = 'custom', className }: HelperTextProps) => {
  const textClasses = cn(
    'ui-text-caption-xs',
    type === 'error' && 'ui-text-danger',
    (type === 'size' || type === 'custom') && 'ui-text-secondary',
    className
  );

  return <p className={textClasses}>{children}</p>;
});

HelperText.displayName = 'HelperText';
